function xlaInit(appid, secret) {
	var xla = window.xla || (window.xla = []);
	xla.push({
		type: 'config',
		appid: appid || 20009,
		secret: secret || 'a8d1fc968b2fe1fe21bfe8f2abc4ba3a'
	});
	var s = document.createElement('script');
	s.src = '//res-etl-ssl.xunlei.com/v1.0.0/xla.min.js';
	s.async = true;
	document.getElementsByTagName('head')[0].appendChild(s);
}

(function() {
	var s = document.createElement("script");
	s.src = "//hm.baidu.com/hm.js?be94a17b28798d3dc61eb511641cdd9a";
	s.async = true;
	document.getElementsByTagName('head')[0].appendChild(s);
})();

(function() {
	if (window.addEventListener && window.console) {
		var s = document.createElement('script');
		s.src = 'https://img-vip-ssl.a.88cdn.com/lib/vip-report/1.0.0/vip-report.min.js';
		s.async = true;

		document.getElementsByTagName('head')[0].appendChild(s);
	}
	if (window.addEventListener && window.console) {
		var sLogging = document.createElement('script');
		sLogging.src = 'http://vip.xunlei.com/lib/vip-logging/1.1.2/vip-logging.js';
		sLogging.async = true;

		document.getElementsByTagName('head')[0].appendChild(sLogging);
	}
})();

function tj(id) {
	if (!id) {
		return;
	}
	window.habo_aid = id;
	var s = document.createElement('script');
	s.src = '/static/com/pv_click_v2.js';
	s.async = true;
	document.getElementsByTagName('head')[0].appendChild(s);
}

module.exports = {
	tj: tj,
	xlaInit: xlaInit
};



//////////////////
// WEBPACK FOOTER
// ./src/common/tj.js
// module id = 11
// module chunks = 2